import _ from 'lodash';

export const myColours = [
    '#45BFFC',
    '#CD5CD8',
    '#3DF2C3',
    '#EB1458',
    '#782ABE',
    '#7DD3F4',
    '#E18FEF',
    '#94F7DB',
    '#F94B8A',
    '#9265CC',
    '#4A89E5',
    '#9A4CD9',
    '#2ECE9D',
    '#BF104F',
    '#422960'
];

/**
 * Get scatter graph chart Dataset
 */
export const chartDataSets = (state) => {
    let chartData = state.dayOneAssessmentResults.scatter.data;
    let type = state.dayOneAssessmentResults.scatter.labels.type;
    let padding = 0; // Whether we start at 0 or 1 ticks
    let data = [];
    let colour = 0;

    if (Object.keys(chartData).length) {
        for (let group in chartData) {
            let axes = _.sortBy(chartData[group], (claim) => {
                return claim.cost.total_initial_reserve;
            }).map((claim, index) => {
                return {
                    x: index + 1,
                    y: claim.cost.total_initial_reserve,
                }
            });

            data.push({
                    label: group,
                    backgroundColor: myColours[colour],
                    borderColor: myColours[colour],
                    data: axes
                },
            )

            colour++;
        }
    }

    return data;
};

/**
 * Get scatter graph chart Dataset
 */
export const makeChartGroup = (chartData, group) => {
    let padding = 0; // Whether we start at 0 or 1 ticks
    let data = [];
    let colour = 0;

    if (Object.keys(chartData).length) {
        for (let group in chartData) {
            let axes = chartData[group].map((point, index) => {
                return {
                    x: index + 1,
                    y: point[key],
                }
            });

            data.push({
                    label: group,
                    backgroundColor: myColours[colour],
                    borderColor: myColours[colour],
                    data: axes
                },
            )

            colour++;
        }
    }

    return data;
};

/**
 * Get scatter graph chart Ticks
 */
export const chartTicks = (state) => {
    let type = state.dayOneAssessmentResults.scatter.labels.type;

    return {
        callback: (value, index, values)  => Math.floor(value) === value ? value : null,
        min: 0, // it is for ignoring negative step.
        beginAtZero: true,
        autoSkip: true,
        maxTicksLimit: 10,
        suggestedMin: 0,
        suggestedMax: Object.keys(state.dayOneAssessmentResults.scatter.data).length + 1,
        // userCallback: (label, index, labels) => {
        //     switch (type) {
        //         case 'claim_type':
        //         case 'disease_type':
        //         case 'gender':
        //             return '';
        //         default:
        //             return Object.keys(state.dayOneAssessmentResults.scatter.data)[label];
        //     }
        // }
    }
};

/**
 * Get confidence graph chart Dataset
 */
export const confidenceChartDataSets = (state) => {
    let confidence = state.dayOneAssessmentResults.confidence.percentage;
    let confidenceColours = getConfidenceColours(confidence);

    return [{
        data: [confidence,(100 - confidence)],
        backgroundColor: confidenceColours,
        hoverBackgroundColor: confidenceColours
    }]
};

/**
 * Get colours for confidence chart
 */
function getConfidenceColours(confidence) {
    switch (true) {
        case (confidence <= 30):
            return ['#D94C8C', '#cbcbcb'];
            break;
        case (confidence <= 60):
            return ['#edf97b', '#cbcbcb'];
            break;
        case (confidence <= 100):
            return ['#3DF2C3', '#cbcbcb'];
            break;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/shared/chartDataSets.js